/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";
import type { IgnoreListsModel } from "./types";
import { ENTITY_TYPE_MAP } from "./constants";

interface EntityWithDetails {
  type: string;
  label: string;
  entityType: number;
  objectKeys: string[];
}

/**
 * Derives entity types from ignore lists data with details
 */
export const useIgnoreListEntities = (
  ignoreListsData: IgnoreListsModel | undefined,
): EntityWithDetails[] => {
  return useMemo(() => {
    if (!ignoreListsData) return [];

    return Object.keys(ignoreListsData).map((key, index) => ({
      type: key,
      label: key.charAt(0).toUpperCase() + key.slice(1),
      entityType:
        ignoreListsData[key as keyof typeof ignoreListsData][0]?.entityType ||
        index,
      objectKeys: Object.keys(
        ignoreListsData[key as keyof typeof ignoreListsData][0] || {},
      ).filter((k) => k !== "id" && k !== "entityType"),
    }));
  }, [ignoreListsData]);
};

/**
 * Processes ignore list data to handle special cases like VehicleCreditHireClientIds
 */
export const useProcessedIgnoreList = (
  ignoreListsData: IgnoreListsModel | undefined,
  entityType: string,
) => {
  return useMemo(() => {
    const list =
      ignoreListsData?.[entityType as keyof typeof ignoreListsData] || [];

    // For vehicleCreditHireClientIds, map clientId to id for DataGrid
    if (entityType === ENTITY_TYPE_MAP.VEHICLE_CREDIT_HIRE_CLIENT_IDS) {
      return list.map((item: any) => ({
        ...item,
        id: item.clientId || item.id,
      }));
    }

    return list;
  }, [ignoreListsData, entityType]);
};
